import React from "react";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import _ from "lodash";
import { useAvailableOption } from "@/hooks/dataTable";
import { useSelector, useDispatch } from "react-redux";
import { setDateGrouping } from "@/features/dataTableSlice";

export function GroupSelection(props) {
  const options = useAvailableOption();
  const dispatch = useDispatch();
  const dateGrouping = useSelector((state) => state.dataTable.dateGrouping);
  React.useEffect(() => {
    if (!_.includes(options, dateGrouping)) {
      dispatch(setDateGrouping({ value: options[0] }));
    }
  }, [dateGrouping]);
  const handleDateGroupChange = (e) => {
    dispatch(setDateGrouping({ value: e.target.value }));
  };
  return (
    <FormControl sx={{ m: 1, width: 120 }}>
      <InputLabel id="dateGrouping-select-label">分佈</InputLabel>
      <Select
        labelId="dateGrouping-select-label"
        id="dateGrouping-select"
        value={dateGrouping}
        label="date"
        onChange={handleDateGroupChange}
      >
        <MenuItem disabled={!_.find(options, (o) => o === "day")} value={"day"}>
          每日
        </MenuItem>
        <MenuItem
          disabled={!_.find(options, (o) => o === "month")}
          value={"month"}
        >
          月份
        </MenuItem>
        <MenuItem
          disabled={!_.find(options, (o) => o === "quarter")}
          value={"quarter"}
        >
          季度
        </MenuItem>
        <MenuItem
          disabled={!_.find(options, (o) => o === "year")}
          value={"year"}
        >
          年份
        </MenuItem>
        <MenuItem
          disabled={!_.find(options, (o) => o === "selected_period")}
          value={"selected_period"}
        >
          已選時段
        </MenuItem>
      </Select>
    </FormControl>
  );
}
